import { useTranslation } from 'react-i18next'

import { ExtraHeaderContent, Header } from 'adminDashboard/benefitDetails/common/ProductClassSummaryComponents'

import { EligibleExpenseType } from 'core/application/adminDashboard/benefitDetails/design/perks/productClass/getProductClassDesignSummary'

import { Collapse, CollapseItem, Icon } from 'common/components'

import { formatYear, parseZoneFormat } from '../../../../common/dateFormatters'

type SubCollapseProps = SubCollapseElementTypes & {
  collapseKey: number
}

type SubCollapseElementTypes = {
  title: string
  monthlyAllowance: number | string
  eligibleCategories: EligibleExpenseType[]
  className?: string
  offerSameAllowance: boolean
  allowanceFrequency: string
  startDate: Date
  endDate: string
  activePlanPeriodEndDate: string
}

export const SubCollapseElement = ({
  title,
  monthlyAllowance,
  eligibleCategories,
  collapseKey,
  className = '',
  offerSameAllowance,
  allowanceFrequency,
  startDate,
  endDate,
  activePlanPeriodEndDate,
}: SubCollapseProps) => {
  const { t: translate } = useTranslation()
  return (
    <Collapse className="design_classes_collapse mb-16">
      <CollapseItem
        className={`${className} class_design`}
        key={collapseKey}
        header={<Header title={title} />}
        extra={<ExtraHeaderContent content={<></>} />}
        content={
          <div className="class-summary">
            {!offerSameAllowance && (
              <>
                <p className="class-summary__title gray-8">
                  <Icon className="fal fa-money-bill mr-8" />
                  <strong className="gray-7">$</strong>
                  {monthlyAllowance}
                  <span className="pl-4">
                    {translate('admin-dashboard.benefit-details.summary.monthly-allowance-label')}
                  </span>
                </p>
                <strong className="class-summary__subtitle gray-7">
                  {translate('admin-dashboard.benefit-details.summary.allowance-frequency')}
                </strong>
                <p className="class-summary__title gray-8">
                  <Icon className="fal fa-check mr-8" />
                  {allowanceFrequency}
                </p>

                <strong className="class-summary__subtitle gray-7">
                  {translate('admin-dashboard.benefit-details.summary.perk-duration')}
                </strong>
                <p className="class-summary__title gray-8">
                  <Icon className="fal fa-clock mr-8" />
                  {parseZoneFormat(startDate)}-{' '}
                  {formatYear(endDate) !== formatYear(activePlanPeriodEndDate)
                    ? parseZoneFormat(endDate)
                    : 'Continuous'}
                </p>
              </>
            )}
            <strong className="class-summary__subtitle gray-7">
              {translate('admin-dashboard.benefit-details.summary.summary-label')}
            </strong>
            {eligibleCategories.map((item) => (
              <p key={item.id} className="class-summary__item gray-8">
                <Icon className="fal fa-check mr-8" />
                {item.name}
              </p>
            ))}
          </div>
        }
      ></CollapseItem>
    </Collapse>
  )
}
